var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoBatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_943_21434)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 32,
    fill: "#363853"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 31.4,
    stroke: "white",
    strokeWidth: 1.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_943_21434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.842 32.471L25.7634 47.0089L39.2197 52.905L61.8297 41.0825L56.6398 30.8614L51.452 20.6484L28.842 32.471Z",
    fill: "#FABE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4304 34.2336L26.3995 47.729L38.3701 56.4008L62.982 49.8061L57.0423 27.6389L32.4304 34.2336ZM35.6477 47.6724C34.4346 47.9975 33.1813 47.2498 32.8468 46.0014C32.5123 44.7531 33.2239 43.4789 34.4369 43.1539C35.65 42.8288 36.9033 43.5765 37.2378 44.8249C37.5723 46.0732 36.8608 47.3474 35.6477 47.6724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.994 50.4167L38.2168 57.3237L25.3615 48.0072L31.8373 33.5153L57.6146 26.6083L63.9929 50.4126L63.994 50.4167ZM38.5219 55.4872L61.9644 49.2058L56.4623 28.6717L33.0198 34.9531L27.4337 47.4519L38.5208 55.4831L38.5219 55.4872ZM35.8682 48.4951C34.2176 48.9374 32.5077 47.9172 32.0525 46.2187C31.5974 44.5201 32.5722 42.7806 34.2188 42.3394C35.8654 41.8982 37.5794 42.9173 38.0345 44.6158C38.4896 46.3144 37.5149 48.0539 35.8682 48.4951ZM34.6575 43.9766C33.8859 44.1833 33.4307 44.9984 33.6435 45.7924C33.8562 46.5864 34.6579 47.0647 35.4296 46.858C36.2012 46.6512 36.6563 45.8361 36.4435 45.0421C36.2308 44.2481 35.4291 43.7698 34.6575 43.9766Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1276 36.4462L48.8856 39.6597L52.993 39.1908L50.9021 42.8262L52.6618 46.6888L48.6149 45.7289L45.594 48.5826L45.1866 44.3576L41.5582 42.2547L45.3497 40.6071L46.1276 36.4462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.334 44.7257L22.6685 47.8514L23.1071 49.4886L34.7727 46.3628L34.334 44.7257Z",
    fill: "#282D33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_943_21434",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.760784 0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_943_21434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_943_21434",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_943_21434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.5789,
    height: 32,
    fill: "white",
    transform: "translate(17.7959 29.6666) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBatch);
export default __webpack_public_path__ + "static/media/noBatch.6ed35188d26e1215b6c1c5cf06f66612.svg";
export { ForwardRef as ReactComponent };